import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import Hero from "src/components/Hero/Hero";
import { Col, Row } from "react-bootstrap";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import EventFinished from "src/components/EventFinished";

const BirthdayBash2025 = () => {
  const { t, i18n } = useTranslation();

  return (
    <BirthdayBash2025Div>
      <EventFinished scheduleKeyName="birthdayBash2025" eventType="promotion" />
      <Hero
        bgImage={`promotions/gaming-machines/birthday-bash-2025/birthday-bash-hero-one-image-2400x800px.jpg`}
        buttonSettings={null}
        image={`promotions/gaming-machines/birthday-bash-2025/Happy-Birthday-signature-v2-${i18n.language}.png`}
        darkenBg={0.5}
        title={t("birthdayBash2025.hero.title")}
      />
      <MainContentDiv>
        <ContainerDiv>
          <ReactMarkdown className="hero-text">
            {t("birthdayBash2025.hero.content.text")}
          </ReactMarkdown>
          <Row className="g-4 mb-2 mb-md-3 prizes-section justify-content-center align-items-center">
            <Col xs={12} md={5} className="m-0">
              <ReactMarkdown>
                {t("birthdayBash2025.hero.content.tier.silver")}
              </ReactMarkdown>
              <ReactMarkdown>
                {t("birthdayBash2025.hero.content.tier.gold")}
              </ReactMarkdown>
            </Col>
            <Col xs={12} md={5} className="m-0">
              <ReactMarkdown>
                {t("birthdayBash2025.hero.content.tier.red")}
              </ReactMarkdown>
              <ReactMarkdown>
                {t("birthdayBash2025.hero.content.tier.black")}
              </ReactMarkdown>
            </Col>
          </Row>
          <ReactMarkdown className="hero-text">
            {t("birthdayBash2025.hero.content.freePlay")}
          </ReactMarkdown>
        </ContainerDiv>
      </MainContentDiv>
      <Hero
        bgImage={`promotions/gaming-machines/birthday-bash-2025/birthday-bash-hero-image-2400x560px.jpg`}
        buttonSettings={null}
        image={`promotions/gaming-machines/birthday-bash-2025/birthday-bash-2400x2400px-${i18n.language}.png`}
        darkenBg={0.5}
        className="second-hero"
        title={t("birthdayBash2025.title")}
      />
      <MainContentDiv>
        <ContainerDiv>
          <ReactMarkdown className="description-text">
            {t("birthdayBash2025.eventDetails.intro")}
          </ReactMarkdown>

          <ReactMarkdown className="prizes-text">
            {t("birthdayBash2025.eventDetails.prizes")}
          </ReactMarkdown>
        </ContainerDiv>
        <WideContainer>
          <ContainerDiv>
            <Row className="g-2 m-0 d-flex prizes-section justify-content-center align-items-end">
              <ReactMarkdown className="prize-text">
                {t("birthdayBash2025.eventDetails.prizeBreakdown.title")}
              </ReactMarkdown>
              <Col xs={12} md={4} className="prize1">
                <ResponsiveImage
                  src={`promotions/gaming-machines/birthday-bash-2025/images/gift-500-${i18n.language}.png`}
                  alt="Prize 1"
                />
                <ReactMarkdown>
                  {t("birthdayBash2025.eventDetails.prizeBreakdown.8PM")}
                </ReactMarkdown>
              </Col>
              <Col xs={12} md={4} className="prize2">
                <ResponsiveImage
                  src={`promotions/gaming-machines/birthday-bash-2025/images/gift-1000-${i18n.language}.png`}
                  alt="Prize 2"
                />
                <ReactMarkdown>
                  {t("birthdayBash2025.eventDetails.prizeBreakdown.9PM")}
                </ReactMarkdown>
              </Col>
              <Col xs={12} md={4} className="prize3">
                <ResponsiveImage
                  src={`promotions/gaming-machines/birthday-bash-2025/images/gift-2000-${i18n.language}.png`}
                  alt="Prize 3"
                />
                <ReactMarkdown>
                  {t("birthdayBash2025.eventDetails.prizeBreakdown.10PM")}
                </ReactMarkdown>
              </Col>
            </Row>
          </ContainerDiv>
        </WideContainer>
        <ContainerDiv>
          <Row className="d-flex justify-content-center align-items-center">
            <Col xs={12} md={12} className="list-text">
              <ReactMarkdown className="how-to-earn">
                {t("birthdayBash2025.eventDetails.howToEarnEntries")}
              </ReactMarkdown>
              <ReactMarkdown className="event-details">
                {t("birthdayBash2025.eventDetails.activationReminder")}
              </ReactMarkdown>
              <ReactMarkdown className="event-details">
                {t("birthdayBash2025.eventDetails.eventInfo")}
              </ReactMarkdown>
            </Col>
            <ReactMarkdown className="extras">
              {t("birthdayBash2025.eventDetails.extras")}
            </ReactMarkdown>
          </Row>
        </ContainerDiv>
      </MainContentDiv>
    </BirthdayBash2025Div>
  );
};

const BirthdayBash2025Div = styled.div`
  width: 100%;
  height: auto;
  background: var(--lightblack);
  color: var(--white);
  .hero_text_container {
    background-color: none;
    background: linear-gradient(
      to right,
      #b67a24 0%,
      /* left: dark gold */ #f1c45e 50%,
      /* center: bright gold */ #b67a24 100% /* right: dark gold */
    ) !important;

    h1 {
      color: var(--black);
      text-shadow: none;
    }
  }
  .second-hero {
    padding-top: 0;
    margin-top: 0;
    .hero_image_container {
      max-height: 500px;
    }
  }
  .hero-text {
    display: flex;
    flex-direction: column;
    gap: 10px;
    text-align: center;
    h4 {
      color: #ffbb2c !important;
      text-transform: uppercase;
      font-size: 2rem;
    }
  }
  @media (max-width: 768px) {
    .hero-text {
      gap: 0;
    }
  }
`;

const MainContentDiv = styled.div`
  height: auto;
  width: 100%;
  overflow-x: hidden;
  ul {
    padding-left: 0;
  }
  .list-text {
    max-width: 550px;
    text-align: center;
    ul {
      list-style-position: inside;
      li {
        text-align: center;
      }
    }
  }
  .prizes-section {
    text-align: center;
    margin: 20px auto 0 auto;
    .prize-text {
      margin: 0;
      h4 {
        margin: 0;
      }
    }
    h4:first-child {
      color: #ffbb2c;
      font-weight: bold;
      font-size: 1.5rem;
    }
    h4 {
      color: #ffbb2c;
      font-weight: bold;
      font-size: 4rem;
    }
  }

  .highlight-text {
    p {
      text-align: center;
    }
  }

  .description-text {
    margin-bottom: 20px;
    p {
      text-align: center;
    }
  }

  .prizes-text {
    h4 {
      font-size: 2rem;
      font-weight: bold;
      color: #ffbb2c;
      text-align: center;
      text-transform: uppercase;
    }
  }

  .prize1 {
    img {
      max-height: 120px;
    }
  }
  .prize2 {
    img {
      max-height: 150px;
    }
  }
  .prize3 {
    img {
      max-height: 180px;
    }
  }

  .how-to-earn {
    h4 {
      color: #ffbb2c;
      font-weight: bold;
    }
  }

  .event-details {
    margin-top: 20px;
    h4 {
      color: #ffbb2c;
      font-weight: bold;
    }
  }

  .extras {
    text-align: center;
    max-width: 600px;
    h4 {
      font-weight: bold;
      color: #ffbb2c;
    }
    p {
      text-align: center;
    }
  }
  @media (max-width: 768px) {
    .prizes-section {
      margin: 10px auto 0 auto;
    }
  }
`;
const WideContainer = styled.div`
  position: relative;
  width: 100%;
  background: #4e0065;
  container-div {
    background: transparent !important;
  }
`;
const ContainerDiv = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 1rem;
  @media (min-width: 992px) {
    padding: 2rem 1rem;
  }
`;
export default BirthdayBash2025;
